import helper from '@/commons/helper';
import axios from 'axios';

export default {

  getAccountDetail() {
    const url = helper.initUrl('owner/unit/account');
    return axios.get(url);
  },

  getCalendars(year) {
    const url = helper.initUrl('owner/unit/calendar/' + year);
    return axios.get(url);
  },

  getLoginSetting(prefixCode) {
    const endpoint = 'owner/' + prefixCode + '/settings';
    const url = helper.initUrl(endpoint, false);
    return axios.get(url);
  },

  getFinancialDetail(year) {
    const endpoint = 'owner/unit/financial/detail/' + year;
    const url = helper.initUrl(endpoint);
    return axios.get(url);
  },

  getStatementSummary() {
    const url = helper.initUrl('owner/unit/statements');
    return axios.get(url);
  },

  getHtmlStatement(statementId) {
    const endpoint = 'owner/unit/statement/' + statementId;
    const url = helper.initUrl(endpoint);
    return axios.get(url);
  },

  destroySession() {
    const url = helper.initUrl('owner/unit/session/destroy');
    return axios.get(url);
  },

  getSecretQuestion(prefixCode, unitId) {
    const endpoint = 'owner/' + prefixCode + '/unit/' + unitId + '/password/secretQuestion';
    const url = helper.initUrl(endpoint, false);
    return axios.get(url);
  },

  // :TODO: RJW - Change these to fixed params or strongly typed objects
  resetPassword(data, prefixCode, unitId) {
    const endpoint = 'owner/' + prefixCode + '/unit/' + unitId + '/password/reset';
    const url = helper.initUrl(endpoint, false);
    return axios.post(url, data);
  },

  changePassword(data) {
    const url = helper.initUrl('owner/unit/authentication');
    return axios.post(url, data);
  },

  checkUnitAvailable(data) {
    const url = helper.initUrl('owner/unit/availability');
    return axios.post(url, data);
  },

  bookUnit(data) {
    const url = helper.initUrl('owner/unit/book');
    return axios.post(url, data);
  },

  updateAuthSettings(data) {
    const url = helper.initUrl('owner/unit/authentication');
    return axios.post(url, data);
  },

  createSession(prefixCode, unitId, password) {
    const url = helper.initUrl('owner/unit/session/create', false);

    const data = {
      prefixCode: prefixCode,
      unitId: unitId,
      password: password
    };

    return axios.post(url, data);
  }
};
